import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

type OptionalSectionProps = {
  title: string;
  hint?: string;
  last?: boolean;
  disabled?: boolean;
  children: ReactNode;
};

export function OptionalSection({
  title,
  hint,
  last,
  disabled,
  children,
}: OptionalSectionProps) {
  return (
    <div
      className={cn("optional-section", last && "last")}
      style={{ opacity: disabled ? 0.7 : 1 }}
    >
      <div className="optional-section-header">
        <div className="optional-section-title">{title}</div>
        {hint && <div className="optional-section-hint">{hint}</div>}
      </div>
      {children}
    </div>
  );
}
